import { useTranslation } from 'react-i18next';

import { InventoryWidget } from '@/modules/home';
import LatestPeriodicOperations from '@/modules/home/components/PageContent/Inputs/PeriodicOperations';
import { Typography } from '@/shared/components/atoms';

import Sprayer from '~/images/sideMenu/sprayer.svg';

const Inputs = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className='mb-24 flex items-center gap-8 text-primary-default'>
        <Sprayer width='24' height='24' />
        <Typography variant='h3' weight='bold'>
          {t('Inputs')}
        </Typography>
      </div>
      <div className='grid gap-24 desktop:grid-cols-2'>
        <InventoryWidget />
        <LatestPeriodicOperations />
      </div>
    </div>
  );
};

export { Inputs };
